import React from 'react';
import Spinner from 'src/view/shared/Spinner';
import InventarioFormPage from '../form/InventarioFormPage';

function InventarioView(props) {
  const renderView = () => {
    const {record, drawer} = props;
    return <InventarioFormPage record={record} disabled={true} drawer={drawer} />;
  };

  const {record, loading} = props;

  if (loading || !record) {
    return <Spinner />;
  }

  return renderView();
}

export default InventarioView;
